export type KioskStage =
  | { view: 'feed' }
  | {
      view: 'pin';
      employeeId: number;
      fullName: string;
      intent: 'start' | 'end';
      lockedContractDateId: number | null;
      /** true when this reopen was triggered by a 401 PIN_VERIFICATION_REQUIRED (expired token). */
      expired: boolean;
    }
  | {
      view: 'clock-in';
      employeeId: number;
      fullName: string;
      lockedContractDateId: number | null;
      pinToken: string | null;
    }
  | { view: 'clock-out'; employeeId: number; fullName: string; pinToken: string | null };

export const FEED_STAGE: KioskStage = { view: 'feed' };

/** Remount key so React never reuses a view instance across two different stage objects. */
export const stageKey = (s: KioskStage): string => (s.view === 'feed' ? 'feed' : `${s.view}-${s.employeeId}`);

export const KIOSK_STAGE_FADE_MS = 260;
export const KIOSK_STAGE_ZOOM_MS = 340;
